/* eslint-disable no-nested-ternary */
/* eslint-disable react/prop-types */
import { Box, TableCell, TableRow } from "@mui/material";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import moment from "moment/moment";
import React from "react";
import tableStyle from "../../theme/styles/table";
// import { getOSCollective } from "../../utils";
// import { isEmptyObj } from "../../utils/helper";
import { isEmptyObj } from "../../utils/helper";
import { tabelCellWidth, style } from "./styles";

function AppointmentInterview({ member }) {
  if (isEmptyObj(member) || isEmptyObj(member.memberDetails)) {
    return null;
  }
  return (
    <TableRow style={tableStyle.tableRow}>
      <TableCell style={{ ...style.Cell, color: "#043D90", fontWeight: "600" }}>
        {member.memberDetails.memberId}
      </TableCell>
      <TableCell style={style.Cell}>
        {member.memberDetails.fullName || "-"}
        <br />
        {member.memberDetails.addressLine1 || "-"}
      </TableCell>
      <TableCell style={style.Cell}>
        {member.memberDetails.mobileNumber || "-"}
        <br />
        {member.memberDetails.emailId || "-"}
      </TableCell>
      <TableCell style={style.Cell}>
        {member.memberDetails.divisionName || "-"}
      </TableCell>
      <TableCell style={{ ...style.Cell, ...tabelCellWidth.medium }}>
        {member.structureLevel === "BLOCK"
          ? [
              member?.memberDetails?.areaName,
              member?.memberDetails?.zoneName,
              member?.memberDetails?.regionName,
              member?.memberDetails?.chapterName,
              member?.memberDetails?.districtName,
              member?.memberDetails?.blockName,
            ]
              .filter(Boolean)
              .join("/ ")
          : member.structureLevel === "DISTRICT"
          ? [
              member?.memberDetails?.areaName,
              member?.memberDetails?.zoneName,
              member?.memberDetails?.regionName,
              member?.memberDetails?.chapterName,
              member?.memberDetails?.districtName,
            ]
              .filter(Boolean)
              .join("/ ")
          : member.structureLevel === "CHAPTER"
          ? [
              member?.memberDetails?.areaName,
              member?.memberDetails?.zoneName,
              member?.memberDetails?.regionName,
              member?.memberDetails?.chapterName,
            ]
              .filter(Boolean)
              .join("/ ")
          : member.structureLevel === "REGION"
          ? [
              member?.memberDetails?.areaName,
              member?.memberDetails?.zoneName,
              member?.memberDetails?.regionName,
            ]
              .filter(Boolean)
              .join("/ ")
          : member.structureLevel === "ZONE"
          ? [member?.memberDetails?.areaName, member?.memberDetails?.zoneName]
              .filter(Boolean)
              .join("/ ")
          : [member?.memberDetails?.areaName]}
      </TableCell>
      <TableCell style={style.Cell}>{member.appliedForName || "NA"}</TableCell>
      <TableCell style={style.Cell}>
        {/* {moment(member.interviewedAt).format("L")} */}
        {member.interviewedAt
          ? moment(member.interviewedAt).format("DD/MM/YYYY")
          : "NA"}
      </TableCell>
      <TableCell style={{ color: "#8C8C8C" }}>
        <Box style={style.flexC}>
          <RemoveRedEyeOutlinedIcon style={style.icon} />
          <Box style={{ ...style.ActionBtnContainer }}>
            <Box style={{ ...style.actionBtn }}>MARK INTERVIEW</Box>
          </Box>
        </Box>
      </TableCell>
    </TableRow>
  );
}
export default AppointmentInterview;
